import http from '@/http';

// fae 预约相关的接口

export default {
    /**
     * FEA预约查询
     * @param params
     * date 预约时间 2020-09-03
     * name fae姓名
     * productLine 产品线
     * faeId FEA ID
     * page size
     * @returns {*}
     */
    getDataFae: params => http.post(`joa-crm/crm/fae/query?date=${params.date}&name=${params.name}&productLine=${params.productLine}&segment=${params.segment}&actualLocation=${params.actualLocation}&faeId=${params.faeId}&page=${params.page}&size=${params.size}`),

    /**
     * FAE预订验证接口
     *  userId FAE用户ID
     *  sDateTime 开始时间(yyyy-mm-dd hh:mi:ss)
     *  eDateTime 结束时间(yyyy-mm-dd hh:mi:ss)
     *  id FAEID
     */
    faeSubscribeVerify: (userId, sDateTime, eDateTime, id) => http.post(`joa-crm/crm/fae/faeSubscribeVerify?userId=${userId}&sDateTime=${sDateTime}&eDateTime=${eDateTime}&id=${id}`),


    /**
     * 获取FAE的产品线分工信息接口
     * userId FAE用户ID 303
     */
    faeDivInfo: (userId) => http.post(`joa-crm/crm/fae/faeDivInfo?userId=${userId}`),

    /**
     * 拒绝流程
     * userID FAE用户ID 303
     * processInstanceId 流程实例ID
     * refuseReason 拒绝理由
     */
    refuseTaskByProcessInstanceId: (params) => http.post(`joa-crm/crm/fae/refuseTaskByProcessInstanceId?userID=${params.userID}&processInstanceId=${params.processInstanceId}&refuseReason=${params.refuseReason}`),


    /**
     * FEA预约任务同意
     * userID FAE用户ID 303
     * processInstanceId 流程实例ID
     * refuseReason 拒绝理由 POST
     */

    agreeTaskByProcessInstanceId: (params) => http.post(`joa-crm/crm/fae/agreeTaskByProcessInstanceId?userID=${params.userID}&processInstanceId=${params.processInstanceId}&agreeReason=${params.agreeReason}`),



    /**
     * 日程查询接口
     * startDate 2020-09-03
     * endDate
     * type FAE 请假
     */
    scheduleQuery: (startDate, endDate, type) => http.post(`/joa-crm/crm/fae/scheduleQuery?startDate=${startDate}&endDate=${endDate}&type=${type}`),



}